// extracted by css-extract-rspack-plugin
export default {"buyerContainer":"jkpL_1n1NvQOAUcU__buyerContainer___","multiLine":"M4XMHkkZEaQzEcwE__multiLine___","categoriesContainer":"MyJtmS35607RND5W__categoriesContainer___"};